import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal.jsx';

/**
 * Aktionsliste hinter einem „…“-Knopf (Okt 2026, „App wie Spot“).
 *
 * Der Spot zeigt Karten und Chatkoepfe ohne Icon-Leisten. Was man selten
 * braucht (Kalender-Export, Melden, Verlauf loeschen, Blockieren), liegt hier:
 * auf dem Telefon als Blatt von unten, am Desktop als kleine Karte. Zerstoerende
 * Aktionen stehen unten und tragen Rot im Icon und im Text.
 *
 * - actions: [{ key, icon, label, onSelect, tone?: 'danger', hidden?, description? }]
 */
const ActionSheet = ({ open, onClose, title, actions }) => {
  const visible = actions.filter((a) => !a.hidden);
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm" bodyClassName="p-0">
      <ul className="divide-y divide-border py-1" role="menu" aria-label={title}>
        {visible.map((action) => {
          const Icon = action.icon;
          const danger = action.tone === 'danger';
          return (
            <li key={action.key || action.label} role="none">
              <button
                type="button"
                role="menuitem"
                onClick={() => {
                  onClose();
                  action.onSelect();
                }}
                className={[
                  'flex w-full min-h-[52px] items-center gap-3 px-5 py-3 text-left touch-manipulation',
                  'transition-colors duration-fast hover:bg-foreground/[0.04]',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary',
                ].join(' ')}
              >
                {Icon && (
                  <Icon
                    className={`h-5 w-5 shrink-0 ${danger ? 'text-danger' : 'text-muted-foreground'}`}
                    aria-hidden="true"
                  />
                )}
                <span className="min-w-0">
                  <span className={`block text-title-s font-medium ${danger ? 'text-danger' : 'text-foreground'}`}>
                    {action.label}
                  </span>
                  {action.description && (
                    <span className="block text-meta text-muted-foreground">{action.description}</span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

ActionSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.elementType,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
      onSelect: PropTypes.func.isRequired,
      tone: PropTypes.oneOf(['danger']),
      hidden: PropTypes.bool,
    })
  ).isRequired,
};

export default ActionSheet;
